module.exports = __webpack_public_path__ + "assets/img/wlh.147608c2.png";